// extracted by mini-css-extract-plugin
export default {"borderBox":"borderBox_borderBox__IZp5A"};